import React from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { BgStandardStyled } from './styled';

const BgStandard = ({
  theme_stadard_btn,
  theme_cancel_btn,
  theme_search_btn,
  type = 'button',
  label,
  onClick,
  disabled,
  bgColor,
  txtColor,
}) => {
  const customClass = cx({
    theme_stadard_btn: theme_stadard_btn,
    theme_cancel_btn: theme_cancel_btn,
    theme_search_btn: theme_search_btn,
  });
  return (
    <BgStandardStyled disabled={disabled} bgColor={bgColor} txtColor={txtColor}>
      <div className={customClass}>
        <button
          type={type}
          disabled={disabled}
          className="btn"
          onClick={onClick}
        >
          {label}
        </button>
      </div>
    </BgStandardStyled>
  );
};

BgStandard.propTypes = {};

export default BgStandard;
